import { Schema } from "effect";
import { BrowserObservationLevel } from "@workerstation/shared/browser-observability-model";
import type { BrowserListResponse, BrowserClearResponse } from "@workerstation/shared/observability/browser";
import type { TraceListResponse, TraceReadResponse, TraceClearResponse } from "@workerstation/shared/observability/traces";
import { ResourceStorageError } from "@workerstation/shared/errors/resource";

export class ObservabilityRequestError extends Schema.TaggedError<ObservabilityRequestError>()("ObservabilityRequestError", {
  status: Schema.Literals([400, 404, 405]), message: Schema.String
}) {}
export const ObservabilityFailure = Schema.Union([ObservabilityRequestError, ResourceStorageError]);
export type ObservabilityFailure = typeof ObservabilityFailure.Type;
export const BrowserFilters = Schema.Struct({
  stationId: Schema.optionalKey(Schema.String), search: Schema.optionalKey(Schema.String),
  level: Schema.optionalKey(BrowserObservationLevel), category: Schema.optionalKey(Schema.String),
  sessionId: Schema.optionalKey(Schema.String)
});
export type BrowserFilters = typeof BrowserFilters.Type;
export const BrowserContextWindow = Schema.Struct({ sessionId: Schema.String, since: Schema.Int, before: Schema.Int });
export type BrowserContextWindow = typeof BrowserContextWindow.Type;
export const TraceFilters = Schema.Struct({
  stationId: Schema.optionalKey(Schema.String), status: Schema.optionalKey(Schema.Literals(["ok", "error"])),
  operation: Schema.optionalKey(Schema.String)
});
export type TraceFilters = typeof TraceFilters.Type;
export type BrowserSnapshot = typeof BrowserListResponse.Type;
export type BrowserCleared = typeof BrowserClearResponse.Type;
export type TraceListing = typeof TraceListResponse.Type;
export type TraceDetail = typeof TraceReadResponse.Type;
export type TracesCleared = typeof TraceClearResponse.Type;
